import './style.scss';

function LoadingScreen() {

  return (
    <div className="loading-screen">
        <h1>Tack!</h1>
        Skickar in din ansökan ...
    </div>
  );
}

export default LoadingScreen;
